// extracted by mini-css-extract-plugin
module.exports = {"btnRow":"contributor-list__btn-row___3uqtQ","heading":"contributor-list__heading___1NvbF","contributor":"contributor-list__contributor___1Ic9z"};